// code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze

/**
 * Make obj fully immutable, by freezing the given obj and its children.
 * Note, this only freezes in non-prod env.
 * In prod env, it will be a no-op
 * to avoid performance cost.
 * @method deepFreeze
 * @param {Object} obj
 * @return deep-frozen object
 */

export default function deepFreeze(obj) {
  if (process.env.NODE_ENV === 'production') {
    return obj;
  } else {
    if (!obj || typeof obj !== 'object' || typeof Object.freeze !== 'function') {
      return obj;
    }

    // Freeze properties before freezing self
    Object.keys(obj).forEach(function freezeProp(name) {
      var prop = obj[name];

      // Freeze prop if it is an object
      if (prop && typeof prop === 'object' && !Object.isFrozen(prop)) {
        deepFreeze(prop);
      }
    });

    // Freeze self
    return Object.freeze(obj);
  }
}
